// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import SendPatientSignatureRequestMessage from './data'

export default function SendPatientSignatureRequestMessageFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/SendPatientSignatureRequestMessage">
      <SendPatientSignatureRequestMessage {...props}>
        {children}
      </SendPatientSignatureRequestMessage>
    </Flow>
  )
}
